

export class API {
    static URL: string = "https://api.oberkircher-berufsinfomesse.de/";
}